module.exports = __webpack_public_path__ + "static/media/about_poolup.a0654be2.png";